(($, Drupal) => {
  Drupal.behaviors.serviceCalc = {
    attach: function attach() {
      $('.services-calc__tabs-item').once('add').on('click', function () {
        const el = $(this);
        const elCategory = el.data('tab');

        if (el.hasClass('active')) {
          return;
        }

        $('.services-calc__tabs-item.active').removeClass('active');
        el.addClass('active');

        $('.services-calc__content.active').removeClass('active');
        $(`.services-calc__content[data-category="${elCategory}"]`).addClass('active');
      });


      const calcElemns = drupalSettings.CountriesCalc;
      const calcShippingTypes = drupalSettings.ShippingType;
      const dummyData = {};
      const shippingTypes = {};

      calcElemns.forEach((element, index) => {
        dummyData[index] = element;
      });

      calcShippingTypes.forEach((element, index) => {
        shippingTypes[index] = element;
      });

      const _dummyData = {
        1: {
          country: 'Украина',
          minimum_weight: 0.300,
          price_pr_kg: 8.95,
          exchange: 11036.35,
          additional: {
            buyout: {
              text: 'Выкуп',
              value: 3.00,
              notation: '$',
            },
            guarantee: {
              text: 'Гарантирование',
              value: 2.99,
              notation: '%',
            },
            separator: {
              text: 'Разделитель',
              value: 2.90,
              notation: '$ / место',
            },
            verification: {
              text: 'Проверка содержимого',
              value: 10.00,
              notation: '$',
            },
            invoice: {
              text: 'Вынуть инвойс',
              value: 0.00,
              notation: '$',
            },
            package: {
              text: 'Упаковка',
              value: 3.99,
              notation: '$',
            },
            repackage: {
              text: 'Перепаковка',
              value: 0.00,
              notation: '$',
            },
            photo: {
              text: 'Фото содержимого',
              value: 4.00,
              notation: '$',
            },
            refund: {
              text: 'Возврат по США',
              value: 3.00,
              notation: '$ / место',
            },
          },
        },
        2: {
          country: 'США',
          minimum_weight: 0.400,
          price_pr_kg: 9.95,
          exchange: 12036.35,
          additional: {
            buyout: {
              text: 'Выкуп',
              value: 4,
              notation: '$',
            },
            guarantee: {
              text: 'Гарантирование',
              value: 1.99,
              notation: '%',
            },
            separator: {
              text: 'Разделитель',
              value: 2.90,
              notation: '$ / место',
            },
            verification: {
              text: 'Проверка содержимого',
              value: 10,
              notation: '$',
            },
            invoice: {
              text: 'Вынуть инвойс',
              value: 0,
              notation: '$',
            },
            package: {
              text: 'Упаковка',
              value: 5,
              notation: '$',
            },
            repackage: {
              text: 'Перепаковка',
              value: 1,
              notation: '$',
            },
            photo: {
              text: 'Фото содержимого',
              value: 3,
              notation: '$',
            },
            refund: {
              text: 'Возврат по США',
              value: 5,
              notation: '$ / место',
            },
          },
        },
      };

      $('.sending-calc').once('add').each(function (index) {
        const deliveryOutput = this.querySelector('#sending-calc-delivery-price');
        const additionalOutput = this.querySelector('#sending-calc-additional-price');
        const dutyOutput = this.querySelector('#sending-calc-duty-price');
        const exchangeOutput = this.querySelector('#sending-calc-exchange-price');
        const totalOutput = this.querySelector('#sending-calc-total-price');


        const selectEl = this.querySelector('#sending-calc-select');
        const selectSHT = this.querySelector('#type-calc-select');
        const additionalEl = this.querySelector('#sending-calc-additional');
        const weightInput = this.querySelector('#weight-input');
        const priceInput = this.querySelector('#price-input');
        let values = {};
        let additionalPrice = 0;
        let deliveryPrice = 0;
        let totalPrice = 0;
        let dutyPrice = 0;
        let exchangePrice = 0;
        let guaranteeFlag = false;
        let dutyPriceInUSD = 0;

        for (const [key, value] of Object.entries(dummyData)) {
          const optionMarkup = `
            <option class="custom-option" value="${key}">${value.country}</option>
          `;

          selectEl.insertAdjacentHTML('beforeend', optionMarkup);
        }

        for (const [key, value] of Object.entries(shippingTypes)) {
          const optionMarkupShippingTypes = `<option class="custom-option" value="${key}">${value}</option>`;

          selectSHT.insertAdjacentHTML('beforeend', optionMarkupShippingTypes);
        }

        selectEl.addEventListener('change', function () {
          const selectedValue = this.value;

          values = {};
          calcValues();
          changeValues(selectedValue);
        });

        selectSHT.addEventListener('change', function () {
          const selectedValue = this.value;
          const shipmentWeight = $('#weight-input').val();
          const replaceToDot = shipmentWeight.replace(',', '.');
          const replaceValue = replaceToDot.replace(/[^.\d]/g, '');
          calcDelivery(replaceValue);
        });

        weightInput.addEventListener('input', function () {
          const replaceToDot = this.value.replace(',', '.');
          const replaceValue = replaceToDot.replace(/[^.\d]/g, '');
          calcDelivery(replaceValue);
        });

        priceInput.addEventListener('input', function () {
          const replaceToDot = this.value.replace(',', '.');
          const replaceValue = Number(replaceToDot.replace(/[^.\d]/g, ''));
          const exchangeGel = Number((dummyData[selectEl.value].exchange));


          if (replaceValue === '') {
            values.guarantee = 0;
          } else if (guaranteeFlag) {
            if (priceInput.value < 300) {
              values.guarantee = 1.5 / exchangeGel;
            } else {
              values.guarantee = 1.5 / exchangeGel + (priceInput.value - 300) * Number(dummyData[selectEl.value].additional.guarantee.value) / 100;
            }
          }

          // values['guarantee'] = Number((replaceValue * dummyData[selectEl.value].additional.guarantee.value / 100).toFixed(2));


          const buyoutInput = document.querySelector('.custom-checkbox__input#buyout');

          if (buyoutInput) {
            values.buyout = buyoutInput.checked ? Math.max(+replaceValue * 0.12, 3) : 0;
          }

          calcDuty(replaceValue);
          calcValues();
        });

        changeValues(selectEl.value);

        function calcValues() {
          let sum = 0;

          for (const item of Object.values(values)) {
            sum += item;
          }

          additionalPrice = Number(sum.toFixed(2));
          additionalOutput.innerText = additionalPrice;
          calcTotal();
        }

        function calcDelivery(weightDelivery) {
          let wDelivery = weightDelivery.replaceAll(',', '.');
          const minWeight = dummyData[selectEl.value].minimum_weight;
          const shipmentType = $('#type-calc-select').val(); // 0 = avia, 1 = sea, 2 = Ground
          let price = Number(dummyData[selectEl.value].price_pr_kg);

          if (shipmentType !== '0' && shipmentType !== '2') {
            if (wDelivery < 10 && wDelivery < 30) { wDelivery = 10; }
            if (wDelivery >= 30) { price = 3.99; } else { price = 4.99; }
          }

          // console.log('weightDelivery: '+weightDelivery);


          deliveryPrice = wDelivery > 0 ? Number((Math.max(Number(minWeight), Number(wDelivery)) * price)) : 0;
          deliveryOutput.innerText = deliveryPrice.toFixed(2);
          calcTotal();
        }

        function calcTotal() {
          totalPrice = Number((additionalPrice + deliveryPrice + dutyPriceInUSD));
          totalOutput.innerText = totalPrice.toFixed(2);
          calcExchanges();
        }

        function calcDuty(weightDelivery) {
          const wDelivery = String(weightDelivery).replaceAll(',', '.');
          const exchangeGel = Number((dummyData[selectEl.value].exchange));
          const shipmentPrice = Number(wDelivery);
          const shipmentPriceInGEl = Number(shipmentPrice * exchangeGel);

          if (shipmentPriceInGEl > 301.89) {
            dutyPrice = shipmentPriceInGEl * 18 / 100;
            dutyPriceInUSD = dutyPrice / exchangeGel;
            dutyOutput.innerHTML = (dutyPrice.toFixed(2) / exchangeGel).toFixed(2);
          } else {
            dutyOutput.innerHTML = 0;
            dutyPriceInUSD = 0;
          }

          calcTotal();
        }

        function calcExchanges() {
          exchangePrice = Number((totalPrice * dummyData[selectEl.value].exchange));
          exchangeOutput.innerText = exchangePrice.toFixed(2);
        }

        function createCheckbox(obj, id) {
          const {
            text,
            value,
            notation,
          } = obj;
          const checkboxWrapper = document.createElement('div');
          const checkboxInput = document.createElement('input');
          const checkboxLabel = document.createElement('label');
          const exchangeGel = Number((dummyData[selectEl.value].exchange));


          checkboxWrapper.className = 'custom-checkbox';

          checkboxInput.className = 'custom-checkbox__input';
          checkboxInput.type = 'checkbox';
          checkboxInput.id = id;

          checkboxLabel.className = 'custom-checkbox__label';
          checkboxLabel.setAttribute('for', id);

          const spanMarkup = `
            <span class="custom-checkbox__dedicated">- ${Number(value)}${notation}</span>
          `;

          checkboxLabel.innerHTML = text + spanMarkup;

          checkboxWrapper.append(checkboxInput);
          checkboxWrapper.append(checkboxLabel);

          checkboxInput.addEventListener('change', function () {
            if (this.id === 'guarantee') {
              if (this.checked) {
                if (priceInput.value < 300) {
                  values[this.id] = 1.5 / exchangeGel;
                } else {
                  values[this.id] = 1.5 / exchangeGel + (priceInput.value - 300) * Number(value) / 100;
                }
              } else {
                values[this.id] = 0;
              }

              // values[this.id] = this.checked ? Number((priceInput.value * Number(value) / 100).toFixed(2)) : 0;
              guaranteeFlag = this.checked;
              calcValues();

              return false;
            }

            if (this.id === 'separator') {
              values[this.id] = this.checked ? Number((Number(value)).toFixed(2)) : 0;
              calcValues();

              return false;
            }

            if (this.id === 'buyout') {
              console.log(this.checked, this.id);
              const replaceToDot = priceInput.value.replace(',', '.');
              const replaceValue = Number(replaceToDot.replace(/[^.\d]/g, ''));

              values[this.id] = this.checked ? Math.max(+replaceValue * 0.12, 3) : 0;

              calcValues();

              return false;
            }

            values[this.id] = this.checked ? Number((Number(value)).toFixed(2)) : 0;

            calcValues();
          });

          return checkboxWrapper;
        }

        function renderCheckboxes(array) {
          for (const key of Object.keys(array)) {
            values[key] = 0;
          }

          additionalEl.innerHTML = '';

          for (const [key, value] of Object.entries(array)) {
            const val = value.value;
            if (val !== null) {
              additionalEl.append(createCheckbox(value, key));
            }
          }
        }

        function changeValues(key) {
          const currentCountry = dummyData[key];
          weightInput.value = '';
          priceInput.value = '';
          selectSHT.disabled = false;

          renderCheckboxes(currentCountry.additional);
          calcDelivery(weightInput.value);


          const urlPublic = window.location.href;
          if (urlPublic.includes('chinetidan') || urlPublic.includes('china') || urlPublic.includes('kitaya')) {
            selectSHT.remove(2);
            selectSHT.remove(1);
            // selectSHT.remove(2);
            // selectSHT.value = 0;
            // selectSHT.disabled = true;
            selectEl.disabled = true;
          }

          if (urlPublic.includes('saberdznetidan') || urlPublic.includes('greece') || urlPublic.includes('grecii')) {
            selectSHT.remove(1);
            selectSHT.remove(0);
            // selectSHT.value = 2;
            // selectSHT.disabled = true;
            selectEl.disabled = true;
          }

          if (urlPublic.includes('amerikidan') || urlPublic.includes('usa') || urlPublic.includes('ssha')) {
            selectSHT.remove(2);
            selectEl.disabled = true;
          }
        }
      });

      $('.cost-calc__delivery').each(function (index) {
        const _self = this;
        const deliveryElements = _self.querySelector('.calc-delivery_wrapper').children;

        if (deliveryElements.length) {
          _self.style.display = 'block';

          $('.cost-calc__delivery-inner').once('add').each(function (index) {
            const parentEl = $(this).closest('[data-slider="parent"]');
            const arrowPrev = parentEl.find('.swiper-button-prev').get(0);
            const arrowNext = parentEl.find('.swiper-button-next').get(0);
            const pagination = parentEl.find('.swiper-pagination').get(0);

            const swiper = new Swiper(this, {
              spaceBetween: 20,
              pagination: {
                el: pagination,
                clickable: true,
              },
              navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
              },
              breakpoints: {
                0: {
                  slidesPerView: 1,
                },
                600: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
              },
            });
          });
        } else {
          _self.style.display = 'none';
        }
      });
    },
  };
})(jQuery, Drupal);
